export default function (value) {
  return [undefined, null, ''].includes(value)
}
